module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action-buttons"
  }, [(_vm.step > 0) ? _c('button', {
    staticClass: "alternate-button",
    on: {
      "click": _vm.prev_step
    }
  }, [_c('trans', {
    attrs: {
      "msg": "prev_button"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.step < 5 && _vm.step > 0) ? _c('button', {
    on: {
      "click": _vm.next_step
    }
  }, [_c('trans', {
    attrs: {
      "msg": "next_button"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.step === 0) ? _c('button', {
    on: {
      "click": _vm.next_step
    }
  }, [_c('trans', {
    attrs: {
      "msg": "step0_button"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.step === 5) ? _c('button', {
    on: {
      "click": _vm.next_step
    }
  }, [_c('trans', {
    attrs: {
      "msg": "step5_button"
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21d730a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Buttons.vue
// module id = 69
// module chunks = 0